export const SHIPPING_COST_DRAWER = 'shipping_cost_drawer';
export const SHIPPING_TIME_DRAWER = 'shipping_time_drawer';
export const ASK_QUESTION_DRAWER = 'ask_question_drawer';

export const SHIPPING_COST_DRAWER_CMS = 'shipping_cost_sidebar';
export const SHIPPING_TIME_DRAWER_CMS = 'delivery_time_sidebar';
